module.exports = {"TXTCLI_Club_Settings":{"id":"TXTCLI_Club_Settings","defaultMessage":"Club-Einstellungen"}}